import React from 'react';
import Location from './elements/Location';
import { AppView } from './RootStep';
import { SelectedAddress } from '../App';
import { BuildingInfo } from '../services/MapIframe';
import { Product, ProductCategory } from './ProductsSelection';
import FactsTable from './elements/FactsTable';
import TextButton from './elements/TextButton';
import { CalculatorData } from '../services/CalculatorData';

interface ProductsStepProps {
    appView: AppView,
    setAppView: React.Dispatch<AppView>,
    address: SelectedAddress | null,
    buildingInfo: BuildingInfo | null
    selectedProduct: Product | null
}


function FinishStep(props: ProductsStepProps) {

    const handleStartNew = () => {
        window.location.reload();
    };

    const solarRows = CalculatorData.getProductTableRows(props.buildingInfo, props.selectedProduct);
    const costTableRows = CalculatorData.getCostTableRows(props.buildingInfo, props.selectedProduct);

    const productTable = props.selectedProduct?.category === ProductCategory.SOLAR ?
        <FactsTable title="Solar" rows={solarRows}></FactsTable>
        : <></>;

    return <div className="py-8 mx-6">
        <div className="mx-auto text-center">
            <h2 className="text-base font-semibold leading-7 text-cyan-600">THOR DEMO</h2>
            <p className="mt-2 text-2xl font-bold tracking-tight text-gray-900">Thank you!</p>
            <div className="mt-2">
                <Location label={props.address?.label} small={true}></Location>
            </div>
            <div className={'pt-16 pb-8 text-xl'}>Thank you for submitting your request. </div>
            <h3 className={'mt-12 mb-4 text-xl text-left text-gray-900'}>{props.selectedProduct?.name}</h3>
            {productTable}
            <div className={'mt-4'}>
                <FactsTable title="Total" rows={costTableRows}></FactsTable>
            </div>
        </div>
        <div className="mt-6">
            <div className="mt-6">
                <TextButton text="Start from beginning" onClick={handleStartNew}></TextButton>
            </div>
        </div>
    </div>;
}

export default FinishStep;